import application_settings from '../applicationSettings';
import Event from './Event';
import LocalStorage from '../local_data';

class GetShippingSecondaryPrice extends Event {
    eventName = 'oms_getShippingSecondaryPrice';

    constructor() {
        super();
        this.add();
    }

    /**
     * @override
     * 
     * Event Function for Get shipping secondary price
     * 
     * @param {string} data.location_id -  location id 
     * @param {string} data.main_method_code -  main method code
     * @param {string} data.delivery_method_code -  delivery method code
     * @param {string} data.address_info -  address info 
     * @param {string} data.products -  products
     * @param {string} data.flash_delivery -  flash delivery
     * @return void
     *  
     */
    eventFunction(data) {
        let clientId = data.client_id;
        let thisObj = this;
        let requestId = (data.request_id) ? data.request_id : '';
        let action = (data.action) ? data.action : '';

        let currentLocation = new LocalStorage.CurrentLocation(clientId).getData();
        let selectedProducts = new LocalStorage.CartLocation(currentLocation).getData();
        let products = [];

        if (selectedProducts && Object.keys(selectedProducts).length > 0) {
            Object.keys(selectedProducts).forEach(function (item) {
                products.push({
                    "id": item,
                    "count": selectedProducts[item].item_qty
                });
            });
        }

        let address_info = data.address_info;
        if (address_info) {
            address_info.location_id = currentLocation;
        }

        // request data
        data.endPoint = application_settings.endPoints.shippingSecondaryPrice;
        data.method = 'POST';
        data.data = {
            client_id: clientId,
            location_id: currentLocation,
            main_method_code: data.main_method_code,
            delivery_method_code: data.delivery_method_code,
            address_info: JSON.stringify(address_info),
            products: JSON.stringify(products),
            flash_delivery: data.flash_delivery
        };
    
        // send request
        this.sendRequest(data, function (response) {
            if (response) {
                //format response data
                let data = thisObj.formatResponseData(response);

                //fire success event
                thisObj.onSuccessEvent(data, {'action' : action, 'request_id' : requestId });
            }
        });
    }
}

export default GetShippingSecondaryPrice;